import { sharedApiRequest } from "@/shared/api/request";

import { authApiErrorFromResponse } from "./errors";

// Destination namespace: the spine HTTP surface (zoomwarriors-backend/apps/
// spine_api, mounted at /api/spine/v1/). The fixtures were measured against
// the scopely source at /api/v1/auth/* — same envelopes, mapped path.
const AUTH_API_PREFIX = "/api/spine/v1/auth";

interface AuthRequestOptions {
  // PATCH is here for auth/profile/, whose measured response records
  // `allow: GET, PATCH, HEAD, OPTIONS` — the verb is measured, not guessed.
  method?: "GET" | "POST" | "PATCH";
  body?: unknown;
}

export async function authRequest<T>(path: string, options: AuthRequestOptions = {}): Promise<T> {
  const { method = "GET", body } = options;
  // D3: the spine API is the cookie authority — auth rides httpOnly cookies,
  // so every call sends credentials and no token ever touches JS. The shared
  // request primitive owns that browser transport policy only.
  const res = await sharedApiRequest(`${AUTH_API_PREFIX}/${path}`, { method, body });
  if (!res.ok) {
    throw await authApiErrorFromResponse(res);
  }
  // Measured logout success is 205 Reset Content with no body (204 handled
  // for symmetry); there is nothing to parse.
  if (res.status === 204 || res.status === 205) {
    return undefined as T;
  }
  return (await res.json()) as T;
}
